module.exports = __webpack_public_path__ + "img/dot.486e7eef.svg";